import { useQuery } from "react-query";
import { getAllLabTestOrders } from "services/labTestOrder.service";

interface Params {
  page?: number;
  limit?: number;
  status?: string;
}

export default function useLabTestOrders(params?: Params) {
  return useQuery(
    ["lab-test-orders", params],
    () => getAllLabTestOrders(params),
    { keepPreviousData: true }
  );
}
